<template>
    <ListReports
        ref="reports"
        :load-on-start="false"
        resource="madds"
    />
</template>

<script>
	import API from '@api';
	import ListReports from '@components/List/ListReports';
	import FormControlSector from '@components/Form/Control/FormControlSector';
	import FormControlDatepicker from '@components/Form/Control/FormControlDatepicker';
	import FormControlReportType from '@components/Form/Control/FormControlReportType';
	import ReportTab from './ReportTab';

	export default {
		name: 'ReportTabMADDs',
		mixins: [ReportTab],
		components: {
			FormControlReportType,
			FormControlDatepicker,
			FormControlSector,
			ListReports,
		},
		data() {
			return {
				formData: {
					sectors: [],
					fromDate: null,
					toDate: null,
					mandated: false,
				},
			}
		},
		methods: {
			fetchResourceCount() {
				return API.getMADDs(this.formData).then(response => {
					return response.meta.total;
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
</style>
